<template>
    <div
        class="block rounded-lg bg-white hover:bg-gray-100 px-6 pt-4 pb-6 shadow-lg hover:shadow-xl border-transparent border-t-8 hover:border-teal-500 transition duration-200"
    >
        <a :href="`/profiles/${user.username}`">
            <div class="flex flex-col w-full sm:flex-row items-start">
                <div class="h-16 w-16 mb-3 sm:mb-0 sm:mr-4 flex-none">
                    <user-avatar :username="user.name" :avatar-url="user.avatar_url" />
                </div>
                <div class="flex-grow w-full sm:w-auto">
                    <div class="flex justify-between mb-5 items-start">
                        <div class="flex flex-col">
                            <h3 class="leading-none text-lg sm:text-2xl font-bold text-gray-900">{{ user.name }}</h3>
                            <span class="leading-relaxed text-teal-500 text-base sm:text-xl">
                                {{ user.profile.title }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </a>
        <div>
            <p class="text-gray-600">{{ text }}</p>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        user: {
            type: Object,
            required: true
        },
        text: {
            type: String,
            required: true
        }
    }
};
</script>
